import {
  api,
  type UserGetPricePerformanceParams,
  type UserGetProjectPriceChartParams,
  type UserGetProjectPriceChartSnapshotParams,
} from '../api'

const getMarketPricePerformance = async () => {
  return await api.v1.userGetMarketPricePerformance()
}

const getPricePerformance = async (params: UserGetPricePerformanceParams) => {
  return await api.v1.userGetPricePerformance(params)
}

const getProjectPriceChart = async (params: UserGetProjectPriceChartParams) => {
  return await api.v1.userGetProjectPriceChart(params)
}

const getProjectPriceChartSnapshot = async (
  params: UserGetProjectPriceChartSnapshotParams,
) => {
  return await api.v1.userGetProjectPriceChartSnapshot(params)
}
export default {
  getMarketPricePerformance,
  getPricePerformance,
  getProjectPriceChart,
  getProjectPriceChartSnapshot,
}
